(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fujystal-personalization"] && !Shopify.designMode) return;
  try {
    function checkFujystalReference(input) {
  const file = input.files[0];
  const valid = !file || (['image/jpeg', 'image/png', 'image/webp'].includes(file.type) && file.size <= 10 * 1024 * 1024);
  input.setCustomValidity(valid ? '' : input.dataset.error);
  const field = input.closest('[data-fujystal-personalization]');
  const message = field.querySelector('[data-fujystal-error]');
  message.textContent = valid ? '' : input.dataset.error;
  message.hidden = valid;
  field.querySelector('[data-fujystal-clear]').hidden = !file;
  return valid;
}
document.addEventListener('change', event => {
  if (event.target.matches('[data-fujystal-reference]')) checkFujystalReference(event.target);
});
document.addEventListener('click', event => {
  const button = event.target.closest('[data-fujystal-clear]');
  if (!button) return;
  const input = button.closest('[data-fujystal-personalization]').querySelector('[data-fujystal-reference]');
  input.value = '';
  checkFujystalReference(input);
  input.focus();
});
document.addEventListener('submit', event => {
  if (!(event.target instanceof HTMLFormElement)) return;
  const input = event.target.querySelector('[data-fujystal-reference]');
  if (!input || !input.files.length) return;
  event.stopImmediatePropagation();
  if (!checkFujystalReference(input)) {
    event.preventDefault();
    input.reportValidity();
    return;
  }
  event.target.enctype = 'multipart/form-data';
}, true);
  } catch(e) { console.error(e); }
})();

})();
